/// <reference types="vite/client" />
const STORAGE_URL = 'https://storage.googleapis.com/storage.codementum.com';

export type BuildMode = 'production' | 'staging' | 'development';

function resolveBuildMode(): BuildMode {
  const raw = import.meta.env.MODE;

  if (raw === 'production' || raw === 'staging' || raw === 'development') {
    return raw;
  }
  return 'development';
}

const MODE = resolveBuildMode();

export class CodementumUrl {
  constructor() {
    throw new Error('Cannot create, use the static instance please');
  }

  static buildMode = MODE;
  static baseUrl: `https://codementum.${'co.uk' | 'com'}` =
    MODE === 'production'
      ? 'https://codementum.com'
      : 'https://codementum.co.uk';

  static storage = STORAGE_URL;

  static cookieDomain() {
    return MODE === 'production' ? 'codementum.com' : 'codementum.co.uk';
  }

  static website(path = '') {
    return CodementumUrl.build({
      subdomain: MODE === 'production' ? 'www' : '',
      path
    });
  }

  static panel(path = '') {
    return CodementumUrl.build({ subdomain: 'panel', path });
  }

  static studio(path = '') {
    return CodementumUrl.build({ subdomain: 'studio', path });
  }

  static studio2(path = '') {
    return CodementumUrl.build({ subdomain: 'studio2', path });
  }

  static studioevent(path = '') {
    return CodementumUrl.build({ subdomain: 'studioevent', path });
  }

  static studioevent2(path = '') {
    return CodementumUrl.build({ subdomain: 'studioevent2', path });
  }

  static appmaker(path = '') {
    return CodementumUrl.build({ subdomain: 'appmaker', path });
  }

  static gamemaker(path = '') {
    return CodementumUrl.build({ subdomain: 'gamemaker', path });
  }

  static aiml(path = '') {
    return CodementumUrl.build({ subdomain: 'aiml', path });
  }

  static api(path = '') {
    return CodementumUrl.build({ subdomain: 'api', path });
  }

  static authApi(path = '') {
    return CodementumUrl.api('auth/' + path);
  }

  static panelApi(path = '') {
    return CodementumUrl.api('panel/' + path);
  }

  static appmakerApi(path = '') {
    return CodementumUrl.api('appmaker/' + path);
  }

  static gamemakerApi(path = '') {
    return CodementumUrl.api('gamemaker/' + path);
  }

  static aimlApi(path = '') {
    return CodementumUrl.api('aiml/' + path);
  }

  static studioApi(path = '') {
    return CodementumUrl.api('studio/' + path);
  }

  static studio2Api(path = '') {
    return CodementumUrl.api('studio2/' + path);
  }

  static studioeventApi(path = '') {
    return CodementumUrl.api('studioevent/' + path);
  }

  static studioevent2Api(path = '') {
    return CodementumUrl.api('studioevent2/' + path);
  }

  static studioXApi(projectName: string) {
    if (!projectName) {
      throw new Error("Cannot create a url without 'projectName'");
    }
    return (path = '') => CodementumUrl.api(`${projectName}/${path}`);
  }

  static build({ subdomain, path }: { path?: string; subdomain?: string }) {
    const url = new URL(CodementumUrl.baseUrl);

    if (subdomain) {
      url.host = subdomain + '.' + url.host;
    }

    if (path) {
      url.pathname = path;
    }

    return url.href;
  }
}
